const sizes = [
  { width: 320, height: 50 },
  { width: 300, height: 250 },
  { width: 320, height: 100 },
  { width: 728, height: 90 },
  { width: 160, height: 600 },
  { width: 300, height: 600 },
  { width: 640, height: 640 },
  { width: 120, height: 600 },
  { width: 468, height: 60 },
  { width: 336, height: 280 },
  { width: 250, height: 250 },
  { width: 180, height: 150 },
  { width: 970, height: 250 },
  { width: 234, height: 60 },
  { width: 970, height: 90 },
  { width: 300, height: 50 },
  { width: 320, height: 480 },
  { width: 480, height: 320 },
  { width: 216, height: 36 },
  { width: 168, height: 28 },
  { width: 120, height: 20 },
]

export class BannerBoundingSizeModel {
  constructor({ width, height }) {
    this.width = width
    this.height = height
  }

  get text() {
    return `${this.width} x ${this.height}`
  }

  static assign(data) {
    return new BannerBoundingSizeModel(data)
  }

  static getList() {
    return sizes.map(BannerBoundingSizeModel.assign)
  }

  static find({ width, height }) {
    return this.getList().find(s => s.width === width && s.height === height)
  }
}
